import { render, staticRenderFns } from "./baobiao.vue?vue&type=template&id=3829bc26&scoped=true"
import script from "./baobiao.vue?vue&type=script&lang=js"
export * from "./baobiao.vue?vue&type=script&lang=js"
import style0 from "./baobiao.vue?vue&type=style&index=0&id=3829bc26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3829bc26",
  null
  
)

export default component.exports